module.exports = __webpack_public_path__ + "img/u960.4c2a6848.png";